/** Nav route patterns that support dynamic breadcrumb labels via the registry. */
export const breadcrumbRoutePaths = {
  donorDetail: "/donors/[donorId]",
  campaignDetail: "/campaigns/[campaignId]",
} as const;

export type BreadcrumbRoutePath =
  (typeof breadcrumbRoutePaths)[keyof typeof breadcrumbRoutePaths];
